import { render, staticRenderFns } from "./OnBoarding.vue?vue&type=template&id=0cd6f37c&scoped=true"
import script from "./OnBoarding.vue?vue&type=script&lang=js"
export * from "./OnBoarding.vue?vue&type=script&lang=js"
import style0 from "./OnBoarding.vue?vue&type=style&index=0&id=0cd6f37c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd6f37c",
  null
  
)

export default component.exports